import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLighthouseLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 512,
	height: 438.2,
	viewBox: "0 0 512 438.2",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M322.5,108.5c-3.6-.1-6.7-2.7-6.7-6.4V55.2a6.7,6.7,0,0,1,6.7-6.5,7.4,7.4,0,0,0,7.3-7,7.8,7.8,0,0,0-8-7.9h0a14.2,14.2,0,0,1-11.4-6,67.1,67.1,0,0,0-108.8,0,14.2,14.2,0,0,1-11.4,6h0a7.8,7.8,0,0,0-8,7.9,7.4,7.4,0,0,0,7.3,7,6.7,6.7,0,0,1,6.7,6.5v46.9c0,3.7-3.1,6.3-6.7,6.4a7.5,7.5,0,0,0-7.3,7.1c-.2,4.3,3.6,7.9,8,7.9H321.8c4.4,0,8.2-3.6,8-7.9A7.5,7.5,0,0,0,322.5,108.5ZM297.1,101a7.6,7.6,0,0,1-7.5,7.5H222.4a7.6,7.6,0,0,1-7.5-7.5V56.3a7.6,7.6,0,0,1,7.5-7.6h67.2a7.6,7.6,0,0,1,7.5,7.6Z",
			fill: "#82acff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M492.8,209.6,348.9,65.7a3.8,3.8,0,0,0-6.4,3.1l6.4,56.2a18.8,18.8,0,0,0,5.4,11.1l106,106a19.8,19.8,0,0,1,0,27.8l-90.7,90.7a18.7,18.7,0,0,0-5.2,16.3l6.5,39a3.8,3.8,0,0,0,6.3,2.1L492.8,302.4A65.7,65.7,0,0,0,492.8,209.6Z",
			fill: "#82acff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M335.1,202.7a24.2,24.2,0,0,1,.4,4.5c0,28.9-49.9,36.2-82.5,45.6-22,6.3-48,14.3-48,14.3-19.3,5.6-18,14.5-30.9,14.5-5.2,0-8.9-4.8-8.9-9.5,3.4-19.8,6.6-39.4,8.7-51.3,7.6-31.9,25.5-30.2,33.1-34.1,92.5-26.5,96.7-26.3,106.2-33.7,2.6-2.1,5.9-7.5,9.3-7.5S325.8,146.9,335.1,202.7Z",
			fill: "#82acff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M346.8,272.6c-.8-5.1-2.1-10.3-3.9-10.3-3.6,0-5.8,13.1-34.7,21.5-122,41.8-153.5,36.5-157.4,70.4-.3,2.8-1,7.4-2,12.8L51.7,269.9a19.8,19.8,0,0,1,0-27.8l106-106a18.8,18.8,0,0,0,5.4-11.1l6.4-56.2a3.8,3.8,0,0,0-6.4-3.1L19.2,209.6a65.7,65.7,0,0,0,0,92.8l119.1,119h0c10.1,9,13.3,16.8,22.7,16.8s12.1-11.3,32.4-22.9,53.3-22.2,101.2-36,63.9-18.2,63.9-36.6C358.5,339.1,357,333.2,346.8,272.6Z",
			fill: "#82acff"
		})
	] })
});
export default SvgLighthouseLogo;
